"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatGtrValues = exports.formatGtrValue = void 0;
var _tokens = require("../tokens");
const formatGtrValue = value => {
  if (typeof value === 'number') {
    return `${value}px`;
  }
  if (value === 'auto') {
    return value;
  }

  // Check if value is a GTR value and return the corresponding px value
  if (Object.keys(_tokens.GTR).includes(value)) {
    return _tokens.GTR[value];
  }
  return value;
};
exports.formatGtrValue = formatGtrValue;
const formatGtrValues = values => typeof values === 'object' ? values.map(formatGtrValue).join(' ') : formatGtrValue(values);
exports.formatGtrValues = formatGtrValues;